import React from 'react'
import { omit } from 'lodash-es'
import { Chip } from '@mui/material'
import { AutocompleteRenderGetTagProps } from '@mui/material/Autocomplete'
import { LocationTypesEnum } from '../../../pages/adgroup/settings/geoTargeting/GeoTargetingFields'
import { getGeoLocationChipLabel } from './geoLocationChipLabel'

export type GeoLocationChipOption = {
  name?: string | null
  label?: string | null
  radius?: number | null
}

type RenderGeoLocationChipsOptions = {
  startIndex?: number
  fieldName: string
  onCityRadiusClick?: (cityFieldName: string) => void
}

export function renderGeoLocationChips(
  tagValue: GeoLocationChipOption[],
  getItemProps: AutocompleteRenderGetTagProps,
  locationType: LocationTypesEnum,
  { startIndex = 0, fieldName, onCityRadiusClick }: RenderGeoLocationChipsOptions
): React.ReactNode[] {
  return tagValue.map((option, index) => {
    const globalIndex = startIndex + index
    const cityFieldName = `${fieldName}.[${globalIndex}]`

    const itemProps = getItemProps({ index })
    const { key } = itemProps as typeof itemProps & { key?: React.Key }

    return (
      <Chip
        key={key}
        {...omit(itemProps, ['key', 'alignItems'])}
        label={getGeoLocationChipLabel(option, locationType)}
        onClick={
          onCityRadiusClick && locationType === LocationTypesEnum.Cities
            ? () => onCityRadiusClick(cityFieldName)
            : undefined
        }
      />
    )
  })
}
